/**
 * @file 底部回流App bar组件
 * @author yanyiting@baidu.com
 * */

import {Component} from 'san';
import './index.scss';

export default class InvokeAppBar extends Component {
    static template = `
        <div class="invoke-app-bar-wrap">
            <div class="show-wrap" s-if="isShow && barList.length">
                <div class="close" on-click="close"></div>
                <div class="open-app-btn-wrap" on-click="goClick">
                    <img src="{{currentContent.cover.url}}" class="title-img"/>
                    <div class="info">{{currentContent.title}}</div>
                    <div class="go-btn">去APP</div>
                </div>
            </div>
        </div>
    `;

    initData() {
        return {
            isShow: true,
            barList: [],
            currentIndex: 0
        };
    }

    static computed = {
        currentContent() {
            let currentIndex = this.data.get('currentIndex');
            let barList = this.data.get('barList');
            let res = {};
            if (barList.length > 0) {
                res = barList[currentIndex];
            }
            return res;
        }
    };

    attached() {
        let lastCloseBarTime = sessionStorage.getItem('lastCloseBarTime');
        if (lastCloseBarTime) {
            this.data.set('isShow', false);
        }
        else {
            setInterval(() => {
                this.changeBarContent();
            }, 8000);
        }
    }

    changeBarContent() {
        let barList = this.data.get('barList');
        if (Array.isArray(barList)) {
            let articleLen = barList.length;
            let currentIndex = this.data.get('currentIndex') + 1;

            if (currentIndex >= articleLen) {
                currentIndex = 0;
            }
            this.data.set('currentIndex', currentIndex);
        }
    }

    // 点击关闭
    close() {
        this.data.set('isShow', false);
        sessionStorage.setItem('lastCloseBarTime', (new Date()).getTime());
        this.fire('closeclick');
    }


    // 去看看按钮点击
    goClick() {
        this.fire('go-click', this.data.get('currentContent'));
    }
}
